require('../../../helpers/helpers.js');
require('./_vuecomponents');

var CivicActionCenter = require('./_civicactioncenter').default();
CivicActionCenter.init();

var RegisterToVote  = require('./_registertovote').default();
RegisterToVote.init();

var Maps = require('./_maps').default();
Maps.init();


if (!window.P2A) {
    window.P2A = {};
}

window.P2A.CivicActionCenter = window.P2A.CivicActionCenter || {};

window.P2A.CivicActionCenter = CivicActionCenter;
window.P2A.CivicActionCenter.RegisterToVote = RegisterToVote;
window.P2A.CivicActionCenter.Maps = Maps;

import { iframeResizerContentWindow } from 'iframe-resizer';
iframeResizerContentWindow;
